import React, { memo } from 'react';
import { Modal, Typography, Icon } from '@ann/web-components';
import {
  ModalHeaderContainer,
  ModalContentContainer,
  ItemWrapper,
} from './RemoveDriveAccessModal.styled';

const RemoveDriveAccessModal = ({
  isOpen,
  onClose,
  onConfirm,
  drive,
  isLoading = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium" width="571px">
      <Modal.Header />
      <ModalHeaderContainer>
        <Typography category="title" size="medium" weight="bold">
          Are you sure you want to remove access?
        </Typography>
      </ModalHeaderContainer>
      <Modal.Body>
        <ModalContentContainer>
          <Typography category="body" size="medium" weight="regular" color="body">
            Your agent won't be able to use it for responses until you reconnect it.
          </Typography>
          {drive && (
            <ItemWrapper>
              <Icon name="folder" />
              <Typography category="body" size="medium" weight="regular" color="body">
                {drive.name || 'Unnamed Drive'}
              </Typography>
            </ItemWrapper>
          )}
        </ModalContentContainer>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button 
          label="Cancel" 
          onClick={onClose} 
          type="secondary" 
          disabled={isLoading} 
        />
        <Modal.Button
          label={isLoading ? 'Removing...' : 'Remove access'}
          onClick={handleConfirm}
          disabled={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

RemoveDriveAccessModal.displayName = 'RemoveDriveAccessModal';

export default memo(RemoveDriveAccessModal);

